//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  inheritAttrs: false,
  props: {
    inline: {
      type: Boolean,
      default: false,
    },
    top: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: Boolean,
      default: false,
    },
    side: {
      type: Boolean,
      default: false,
    },
    quite: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    classes () {
      return {
        'k-field-hint--top': this.top,
        'k-field-hint--bottom': this.bottom,
        'k-field-hint--side': this.side,
        'k-field-hint--inline': this.inline
      }
    }
  }
}
